import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Pvmodule } from '@intellio/shared/models';
import { AppConfigService } from './app-config.service';
import { AuthService } from './auth.service';
import { BaseService } from './base-service.service';

@Injectable({
  providedIn: 'root',
})
export class PvmoduleService extends BaseService {
  constructor(
    protected client: HttpClient,
    protected configService: AppConfigService,
    protected authService: AuthService
  ) {
    super(client, configService, authService);
  }

  getPvModules() {
    const url = '/api/pvmodules';
    return this.get<Pvmodule[]>(url);
  }
}
